import { render, staticRenderFns } from "./invite-user-starter.vue?vue&type=template&id=16742e71"
import script from "./invite-user-starter.vue?vue&type=script&lang=js"
export * from "./invite-user-starter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16742e71')) {
      api.createRecord('16742e71', component.options)
    } else {
      api.reload('16742e71', component.options)
    }
    module.hot.accept("./invite-user-starter.vue?vue&type=template&id=16742e71", function () {
      api.rerender('16742e71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/invite-user-starter.vue"
export default component.exports